import AuthRequired from "../shared/AuthRequired";
import Home from "../pages/Home";
import Category from "../pages/Category";
import ProductDetails from "../pages/ProductDetails";
import Search from "../pages/Search";
import Cart from "../pages/Cart";
import Success from "../pages/Success";
import NotFound from "../pages/NotFound";
import Register from "../pages/Register";
import Login from "../pages/Login";
import OrderList from "../pages/OrderList";
import OrderDetails from "../pages/OrderDetails";
import Customer from "../pages/Customer";
export default [
  {
    path: "/",
    element: Home, //is component
  },
  {
    path: "/Category-:id",
    element: Category,
  },
  {
    path: "/ProductDetails-:id",
    element: ProductDetails,
  },
  {
    path: "/Search",
    element: Search,
  },
  {
    path: "/Cart",
    element: Cart,
  },
  {
    path: "/Success",
    element: Success,
  },
  {
    path: "/Register",
    element: AuthRequired.CheckLogged(Register),
  },
  {
    path: "/Login",
    element: AuthRequired.CheckLogged(Login),
  },
  {
    path: "*",
    element: NotFound,
  },
  {
    path: "/Customer",
    element: Customer,
  },
  {
    path: "/OrderList",
    element: OrderList,
  },
  {
    path: "/OrderDetails-:id",
    element: OrderDetails,
  },
];
